import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    header: {
      background: '#ffffff',
    },
  },
  {
    name: 'with-landing',
  },
);

export default useStyles;
